export default {
  mounted(el: HTMLElement, binding: any) {
    handleMaskDirective(el, binding)
  },
  updated(el: HTMLElement, binding: any) {
    handleMaskDirective(el, binding)
  }
}

function handleMaskDirective(el: HTMLElement, binding: any) {
  if (!(el instanceof HTMLInputElement)) return

  const input = el as HTMLInputElement
  const mask = binding.value?.mask || binding.value

  if (!mask) return

  input.addEventListener('input', (e: Event) => {
    applyMask(e.target as HTMLInputElement, mask)
  })

  input.addEventListener('keydown', (e: KeyboardEvent) => {
    handleMaskKeydown(e, mask)
  })

  // Применяем маску к начальному значению
  if (input.value) {
    applyMask(input, mask)
  }
}

function applyMask(input: HTMLInputElement, mask: string) {
  const value = input.value.replace(/\D/g, '')
  let result = ''
  let valueIndex = 0

  for (let i = 0; i < mask.length; i++) {
    if (valueIndex >= value.length) break

    if (mask[i] === '9') {
      // Цифра
      if (/[0-9]/.test(value[valueIndex])) {
        result += value[valueIndex]
        valueIndex++
      }
    } else if (mask[i] === 'a') {
      // Буква
      if (/[a-zA-Zа-яА-Я]/.test(value[valueIndex])) {
        result += value[valueIndex]
        valueIndex++
      }
    } else if (mask[i] === '*') {
      // Любой символ
      result += value[valueIndex]
      valueIndex++
    } else {
      // Статический символ маски
      result += mask[i]
    }
  }

  input.value = result
}

function handleMaskKeydown(e: KeyboardEvent, mask: string) {
  const input = e.target as HTMLInputElement
  const cursorPosition = input.selectionStart || 0

  // Разрешаем удаление и навигацию
  if (
    e.key === 'Backspace' ||
    e.key === 'Delete' ||
    e.key === 'Tab' ||
    e.key === 'ArrowLeft' ||
    e.key === 'ArrowRight' ||
    e.key === 'Home' ||
    e.key === 'End'
  ) {
    return
  }

  // Предотвращаем ввод, если достигнут конец маски
  const valueWithoutMask = input.value.replace(/\D/g, '')
  const maxDigits = (mask.match(/9/g) || []).length

  if (valueWithoutMask.length >= maxDigits && cursorPosition >= input.value.length) {
    e.preventDefault()
    return
  }

  // Проверяем соответствие символу маски в текущей позиции
  const currentMaskChar = mask[getMaskPosition(input.value, mask, cursorPosition)]

  if (currentMaskChar === '9' && !/[0-9]/.test(e.key)) {
    e.preventDefault()
  } else if (currentMaskChar === 'a' && !/[a-zA-Zа-яА-Я]/.test(e.key)) {
    e.preventDefault()
  }
}

function getMaskPosition(value: string, mask: string, cursorPos: number): number {
  let maskPos = 0
  let valuePos = 0

  while (valuePos < cursorPos && maskPos < mask.length) {
    if (mask[maskPos] === '9' || mask[maskPos] === 'a' || mask[maskPos] === '*') {
      valuePos++
    }
    maskPos++
  }

  return maskPos
}

// Предопределенные маски
export const MASKS = {
  PHONE: '+7 (999) 999-99-99',
  DATE: '99.99.9999',
  TIME: '99:99',
  CREDIT_CARD: '9999 9999 9999 9999',
  INN: '9999999999',
  KPP: '999999999',
  OGRN: '9999999999999',
  SNILS: '999-999-999 99'
}
